import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { UtilityService } from './shared/utility.service';
import { SMSDetails, SMSResponse } from '../models/sms.model';
import { delayedRetryHttp } from '../shared/delayedRetry';

@Injectable()
export class RemoteSMSService {
  private baseUrl: string;
  private api: string = "api/RemoteSMS";

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
    this.baseUrl = _baseUrl + this.api;
  }

  private handleErrors(errorResponse: HttpErrorResponse) {
    if (errorResponse.error instanceof ErrorEvent) {
      console.error('SMS Service Client Side Error: ', errorResponse.error.message);
    } else {
      throw errorResponse;
    }
  }

  async sndSMSAsync(encryptedUser: string, sms: SMSDetails, mobileNumber: string): Promise<SMSResponse | void> {
    const a = await this.httpClient.post<SMSResponse>(`${this.baseUrl}/Post/${mobileNumber}`, sms, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + encryptedUser
      })
    }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, sms, "mobileNumber - " + mobileNumber, encryptedUser, "RemoteSMS", "sndSMSAsync"); });

    return a;
  }

}
